
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects-partners",
      function () {
        return require("private-next-pages/projects-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects-partners"])
      });
    }
  